import React from 'react'
import { useHistory } from 'react-router'
import intl from 'react-intl-universal'
import styled from 'styled-components'
import Button from 'components/Button'
import Icon from 'components/Icon'
import { useEventSlug, useSlug } from 'hooks'
import routes from 'routes'
import FileUpload, { IMAGE_ONLY } from 'features/forms/components/FileUpload'
import { colors, _ } from 'utils'
import Switch from '../../forms/components/Switch'
import TextField from '../../forms/components/TextField'

const S = {
    Link: styled.span`
        max-width: 220px;
        height: 28px;
        line-height: 28px;
    `,
    BackToMap: styled.div`
        margin: -40px -10px 20px -10px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: calc(100% + 20px);
        height: 56px;
        padding: 0 20px;
        background-color: rgb(48, 104, 244, 0.05);
    `,
    Description: styled.div`
        display: flex;
        align-items: center;
        font-size: 14px;
        color: ${colors.dark};
        opacity: 0.8;
    `,
    Icon: styled(Icon)`
        margin: 0 10px 3px 0;
    `
}

const Settings = () => {
    const history = useHistory()
    const eventSlug = useEventSlug()
    const mapSlug = useSlug('mapSlug')

    return (
        <>
            <S.BackToMap>
                <S.Description>
                    <S.Icon icon="map" color={colors.primary} size={20} />
                    {intl.getHTML('map_setting.back_to_map_description')}
                </S.Description>
                <Button size="sm" onClick={() => history.push(routes.map.getPath({ eventSlug, mapSlug }))}>
                    {_('map_setting.back_to_map_button')}
                </Button>
            </S.BackToMap>
            <TextField
                label={_('map_setting.form.name')}
                name="parent.name"
                lg={1/2}
            />
            <FileUpload
                label={_('map_setting.form.background_image')}
                name="parent.image"
                placeholder={_('map_setting.form.background_image_placeholder')}
                accept={IMAGE_ONLY}
            />
            <Switch
                label={_('map_setting.form.chat')}
                name="parent.enableChat"
            />
        </>
    )
}

export default Settings
